import styled from "styled-components";
import React, { useEffect, useRef, useState } from 'react';
import { Button, P } from "@src/components/atoms";
import { ThemeType } from "@src/types/theme";
import { useSelector } from "react-redux";
import { RootState } from "@src/store";
import { darkTheme } from "@src/theme/default";
import CartService from "@src/services/cart/CartService";
import { addCart, deleteCart } from "@src/lib/public-lib";
import { MdShoppingCart, MdOutlineShoppingCart } from "react-icons/md";
import { CartItemType } from "@src/types/data";
import { getCookie, setCookie } from "@src/lib/util/cookie";
import Router from "next/router";
import Cart from "@src/components/icons/cart/Cart";
import Download from "@src/components/icons/download/Download";
import { DetailIconsProps } from "./DetailIcons";
import { useTranslation } from "next-i18next";

export default function DetailIconsMobile(props: DetailIconsProps)
{
    const { t } = useTranslation("common");
    const media = useSelector((state: RootState) => state.media);
    const user = useSelector((state: RootState) => state.user);
    
    const [ size, setSize ] = useState("0.75rem");
    const [ like, setLike ] = useState(false);
    const [ cartList, setCartList ] = useState<any[]>([]);
    const [ clickCart, setClickCart ] = useState(!!cartList && cartList.some(e => e && e.LIBRARY_ID === props.library.id));
    const [ download, setDownload ] = useState(false);
    

    const downloadRef = useRef<any>();

    const handleAddCart = async () => {
        if (getCookie("accessToken"))
        {
            await addCart(props.library.id);
            setClickCart(true);
        }
        else
        {
            alert("로그인이 필요합니다.");
        }
    };

    const handleRemoveCart = async () => {
        await deleteCart(props.library.id);
        setClickCart(false);
    };

    const onDownload = async () => {
        setDownload(true);
    };

    const handleBuyClick = () => {
        if (getCookie("accessToken"))
        {
            let list: CartItemType[] = [{
                id: props.library.id,
                title: props.library.title,
                artist: props.library.artist,
                desc: props.library.desc,
                price: props.library.price,
                discountRate: props.library.discountRate,
                isCheck: false,
                genre: props.library.genre
            }]
            setCookie("selectList", JSON.stringify(list));

            Router.push("/pay");
        }
        else
        {
            alert("로그인이 필요합니다.");
            Router.push("/login");
        }
    };
    
    useEffect(() => {
        if (media.isMobile)
            setSize("10vw");
        else
            setSize("0.75rem");
    }, [media]);

    useEffect(() => {
        if (props.library)
        {
            CartService.cartLibraries({ userId: user.id })
			.then(res => setCartList(res));
        }
    }, [props.library]);

    return(
        <Wrapper>
            <UpperWrap>
                <IconWrapper>
                    <MainText>{props.total ? props.total : "2:13"}</MainText>
                    <SubText>{ "재생시간" }</SubText>
                </IconWrapper>
                <IconWrapper style={{ border: "none" }}>
                    <MainText>{ props.library && props.library.bpm ? props.library.bpm : "Unk" }</MainText>
                    <SubText>{ "BPM" }</SubText>
                </IconWrapper>
            </UpperWrap>
            <LowerWrap>
                <MainText style={{ margin: "0 25vw 0 0" }}>
                    { props.library && props.library.price ? `￦ ${props.library.price.toLocaleString()}` : "0" }
                </MainText>
                <div style={{ display: "flex" }}>
                    <ButtonWrapper style={{ marginRight: 20 }}>
                        { clickCart ?
                            <MdShoppingCart style={{ cursor: "pointer" }} size={ 24 } color={ darkTheme.text } onClick={ handleRemoveCart } />
                            :
                            <Cart width={ 32 } height={ 32 } fill="white" onClick={ handleAddCart } />
                        }
                    </ButtonWrapper>
                    <ButtonWrapper onClick={ handleBuyClick }>
                        <Download width={ 37 } height={ 32 } />
                    </ButtonWrapper>
                </div>
            </LowerWrap>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    width: 100%;
    margin: 40px auto 0;
    position: "relative";
    flex: 1;
`;

const UpperWrap = styled.div`
    height: 50px;
    display: flex;
    justify-content: center;
    margin-bottom: 26px;
`;

const LowerWrap = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 24px;
    margin-bottom: 24px;
    border-bottom: 1px solid #999999;
`;

const IconWrapper = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    border-right: 1px solid #999999;
`;

const MainText = styled(P)`
    font-size: 0.24rem;
    color: ${({ theme }: { theme: ThemeType }) => theme.text};
    margin: 0 auto;
    line-height: 1;
    white-space: nowrap;
`;

const SubText = styled(MainText)`
    font-size: 0.14rem;
    line-height: 100%;
    color: #999;
    margin-bottom: 0;
`;

const ButtonWrapper = styled(Button)`
    margin: 0 auto;
`;